import { render, staticRenderFns } from "./Organ.vue?vue&type=template&id=e10fe306&scoped=true&"
import script from "./Organ.vue?vue&type=script&lang=js&"
export * from "./Organ.vue?vue&type=script&lang=js&"
import style0 from "./Organ.vue?vue&type=style&index=0&id=e10fe306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e10fe306",
  null
  
)

export default component.exports